import { labelByFieldOption as frequentlyBoughtTogetherLabels } from './constants/frequently-bought-together.constants';
import { BUSINESS_OBJECTIVE_TO_LOCALIZATION_KEY as onSaleLabels } from './constants/on-sale.constants';
import { labelByFieldOption as othersYouMayLikeLabels } from './constants/others-you-may-like.constants';
import { labelByFieldOption as recommendedForYouLabels } from './constants/recommended-for-you.constants';
import { ModelTypeOption } from './constants/recs-model-type.constants';
export function formatRecsModelId(id) {
    // The ID will look something like
    // `projects/421876732655/locations/global/catalogs/default_catalog/models/test-name_similar-it_1693519656968`.
    // Only the last segment is required.
    return id.split('/').pop();
}
const modelTypesToBusinessObjectiveLabelCollections = {
    [ModelTypeOption.RecentlyViewed]: null,
    [ModelTypeOption.BuyItAgain]: null,
    [ModelTypeOption.FrequentlyBoughtTogether]: frequentlyBoughtTogetherLabels,
    [ModelTypeOption.OnSaleItems]: onSaleLabels,
    [ModelTypeOption.OthersYouMayLike]: othersYouMayLikeLabels,
    [ModelTypeOption.RecommendedForYou]: recommendedForYouLabels,
    [ModelTypeOption.SimilarItems]: null,
};
export function getBusinessObjectiveLabelKey(modelType, businessObjective) {
    var _a;
    return (_a = modelTypesToBusinessObjectiveLabelCollections[modelType]) === null || _a === void 0 ? void 0 : _a[businessObjective];
}
